import React from "react";
import { LoadingDots } from "./HistoryStates";
import { formatSummaryTime } from "../historyFormat";

// The LLM recap, shown above the transcript in an expanded row.
//
// Three states, and all three say what they are: never generated, generated,
// and generated before the conversation grew. Nothing was backfilled, so most
// conversations are in the first state and a blank space there would read as a
// missing feature rather than an available one.
export function SummaryBlock({ conv, language, busy, onGenerate }) {
  const zh = language === "zh";
  const summary = conv.summary;

  if (busy) {
    return (
      <div className="px-3 sm:px-4 py-3 border-b border-gray-100 dark:border-gray-700">
        <div className="flex items-center gap-2 text-xs text-orange-700 dark:text-orange-300">
          <LoadingDots language={language} small />
          {zh ? "正在產生摘要…" : "Generating summary…"}
        </div>
      </div>
    );
  }

  if (!summary) {
    return (
      <div className="px-3 sm:px-4 py-3 border-b border-gray-100 dark:border-gray-700 flex items-center justify-between gap-3">
        <p className="text-xs text-gray-500 dark:text-gray-400">
          {zh
            ? "這段對話還沒有摘要。"
            : "This conversation has no summary yet."}
        </p>
        <button
          className="shrink-0 px-3 py-1.5 rounded-lg bg-orange-500 text-white text-xs font-medium hover:bg-orange-600 transition-colors"
          onClick={() => onGenerate(false)}
        >
          {zh ? "產生摘要" : "Generate summary"}
        </button>
      </div>
    );
  }

  // The recap itself is not repeated here — it is already the row's second line,
  // a few pixels above, and printing it twice made the expanded view open on a
  // paragraph the reader had just finished. What is left is what the row cannot
  // carry: the staleness warning and the way to regenerate.
  return (
    <div className="px-3 sm:px-4 py-2 border-b border-gray-100 dark:border-gray-700 flex items-center justify-between gap-3">
      <p className="text-xs text-gray-400 dark:text-gray-500 min-w-0">
        {summary.stale ? (
          <span className="text-amber-700 dark:text-amber-400">
            {zh
              ? "對話在摘要產生後又有新訊息，摘要可能不完整。"
              : "The conversation has grown since the summary was written, so it may be incomplete."}
          </span>
        ) : (
          <>
            {zh ? "摘要產生於 " : "Summary written "}
            {formatSummaryTime(summary.generated_at, language)}
          </>
        )}
      </p>
      <button
        className="shrink-0 px-3 py-1.5 rounded-lg border border-gray-300 dark:border-gray-600 text-gray-600 dark:text-gray-300 text-xs font-medium hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
        onClick={() => onGenerate(true)}
      >
        {zh ? "重新產生" : "Regenerate"}
      </button>
    </div>
  );
}
